import { useParams } from "react-router-dom";
import { useDb } from "../../contexts/DatabaseContext";
import { useDocument } from "react-firebase-hooks/firestore";
import {
  Alert,
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  LinearProgress,
  Typography,
} from "@mui/material";
import BackLink from "../shared/BackLink";
import { Settings } from "@mui/icons-material";
import { useState } from "react";
import AddEmailToUser from "./AddEmailToUser";

export default function UserDetail() {
  const { userId } = useParams();
  const { getDocRef } = useDb();
  const [snapshot, loading, error] = useDocument(getDocRef("users", userId));
  const [busy, setBusy] = useState(false);
  const [addEmailOpen, setAddEmailOpen] = useState(false);

  // @ts-ignore
  async function copyToClipboard(textToCopy) {
    try {
      await navigator.clipboard.writeText(textToCopy);
      window.alert("Text copied to clipboard successfully!");
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  }

  const user =
    (snapshot && {
      ...snapshot.data(),
      id: snapshot.id,
    }) ||
    {};

  if (loading) {
    return <LinearProgress />;
  }

  if (error) {
    return <Alert severity="error">{error.message}</Alert>;
  }

  return (
    <div>
      <BackLink />
      <h1>{user.phone_number}</h1>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader
              title={user.display_name}
              subheader={`${user.phone_number} / Alt: ${user.alt_number}`}
              avatar={<Avatar src={user.photo_url} />}
            />
            <CardContent>
              <Typography>
                Email: {user.email ? user.email : "Not Set"}
              </Typography>
              <Typography>ID Number: {user.id_number}</Typography>
              <Typography>Nationality: {user.nationality}</Typography>
              <Typography>Address (Street): {user.address1}</Typography>
              <Typography>Address (Suburb): {user.address2}</Typography>
              <Typography>Address (City): {user.address3}</Typography>
              <Typography>Address (Province): {user.province}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader
              title={"Actions"}
              subheader={"Manage this user"}
              avatar={
                <Avatar>
                  <Settings />
                </Avatar>
              }
            />
            <CardActions>
              {
                <Button
                  variant="contained"
                  color="primary"
                  disabled={busy}
                  onClick={() => setAddEmailOpen(true)}
                >
                  Add/Update Email/PW
                </Button>
              }
              <Button
                variant="contained"
                color="primary"
                disabled={busy}
                onClick={() =>
                  copyToClipboard("https://mypav.pavtelecoms.co.za/alt-sign-in")
                }
              >
                Copy Alternate Login Link
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>

      <AddEmailToUser
        open={addEmailOpen}
        onClose={() => setAddEmailOpen(false)}
        userId={userId}
      />
    </div>
  );
}
